module.exports = __webpack_public_path__ + "img/news-slider3-zh.0aa9e6be.jpg";